import { GridOptions } from '@ag-grid-community/core';

import { INVESTIGATOR_FORECAST_DEFAULT_CONFIG } from './investigator-forecast-default-config';
import { getPatientInvoiceablesBufferColDef } from './investigator-forecast-excel-config';
import { INVESTIGATOR_FORECAST_PATIENT_GROUP_COLUMN_DEFS } from './investigator-forecast-patient-group-config';
import { getInvestigatorForecastPeriodColumnDefs } from './investigator-forecast-period-config';
import { getInvestigatorForecastTotalAmountColumnDef } from './investigator-forecast-total-col.config';
import { InvestigatorForecastGridRow } from '../types/investigator-forecast-grid-row';
import { InvestigatorForecastTableContext } from '../types/investigator-forecast-table-context';

export const investigatorForecastTableConfig = (
  ctx: InvestigatorForecastTableContext
): GridOptions<InvestigatorForecastGridRow> => {
  const config = INVESTIGATOR_FORECAST_DEFAULT_CONFIG(ctx);

  return {
    ...config,
    columnDefs: [
      ...INVESTIGATOR_FORECAST_PATIENT_GROUP_COLUMN_DEFS,
      getPatientInvoiceablesBufferColDef(ctx.patientInvoiceablesPercentage),
      ...getInvestigatorForecastPeriodColumnDefs(ctx),
      getInvestigatorForecastTotalAmountColumnDef(ctx),
    ],
  };
};
